import React, { useState, useEffect } from "react";
import {
  Input,
  Form,
  Col,
  Row,
  Button,
  Select,
} from "antd";
import {
  PlusOutlined,
} from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { defaultValidateMessages } from "./Helper";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const BkmSenderAccountAddForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [bankSelect, setBankSelect] = useState({
    data: [],
    loading: false,
  });
  const [accountSelect, setAccountSelect] = useState({
    data: [],
    loading: false,
  });
  const [activeBank, setActiveBank] = useState();
  const [form] = Form.useForm();

  useEffect(() => {
    getBanks();
  }, []);

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  useEffect(() => {
    if (!activeBank) return;

    getAccounts(activeBank);
  }, [activeBank]);

  const getBanks = () => {
    setBankSelect({
      ...bankSelect,
      loading: true,
    });
    RequestHandler.get(`/Bank?$select=id,name&$filter=isSupportBkm eq true`).then((response) => {
      setBankSelect({
        data: response.value,
        loading: false,
      });
    }
    );
  };

  const getAccounts = (bankId) => {
    setAccountSelect({
      ...accountSelect,
      loading: true,
    });
    RequestHandler.get(`/BkmSenderAccount/TenantAccounts?$filter=bankId eq ${bankId}`).then((response) => {
      setAccountSelect({
        data: response,
        loading: false,
      });
    });
  };

  const onSuccess = () => {
    form.resetFields();

    if (props.onSuccess) props.onSuccess();
  };

  const onFinish = (values) => {
    RequestHandler.post(`/BkmSenderAccount`, values).then((response) => {
      setLoading(false);
      if (response.success) {
        onSuccess();
      }
    });
  };

  const onFinishFailed = () => setLoading(false);

  return (
    <Form
      {...formItemLayout}
      validateMessages={defaultValidateMessages}
      form={form}
      name="senderAccountAdd"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row>
        <Col span={24}>

          <Form.Item name="bankId" label="Hesap Sağlayıcı" rules={[{ required: true }]}>
            <Select
              allowClear
              showSearch
              placeholder="Seçiniz"
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
              onChange={value => {
                setActiveBank(value);
                form.setFieldsValue({ tenantAccountId: null, name: null, ownerName: null, iban: null, bkmReference: null });
              }}
              loading={bankSelect.loading}
            >
              {bankSelect.data.map((item) => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="tenantAccountId" label="Kayıtlı Hesap">
            <Select
              allowClear
              showSearch
              placeholder="Seçiniz"
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
              loading={accountSelect.loading}
              onChange={(_, option) => form.setFieldsValue({ name: option.data.name, ownerName: option.data.ownerName, iban: option.data.iban, bkmReference: option.data.bkmReference })}
            >
              {accountSelect.data.map((item) => (
                <Select.Option key={item.id} value={item.id} data={item}>
                  {item.iban + (item.name ? ` (${item.name})` : "")}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="Hesap Adı" name="name" rules={[{ required: true }]}>
            <Input />
          </Form.Item>

          <Form.Item label="Hesap Sahibi Ünvanı" name="ownerName" rules={[{ required: true }]}>
            <Input />
          </Form.Item>

          <Form.Item label="Iban" name="iban" rules={[{ required: true }]}>
            <Input />
          </Form.Item>

          <Form.Item name="bkmReference" hidden>
            <Input />
          </Form.Item>

          <Row justify="space-between">
            <Col>
            </Col>
            <Col>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                htmlType="submit"
                onClick={() => setLoading(true)}
                loading={loading}
              >
                Ekle
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};
export default BkmSenderAccountAddForm;
